import { env } from '../../config/env';
import type { UserAddressInput } from '../../types/api';
import type { UserAddress } from '../../types';
import * as http from './addressesService.http';
import * as mock from './addressesService.mock';

export interface AddressesService {
  fetchAddresses(): Promise<UserAddress[]>;
  createAddress(input: UserAddressInput): Promise<UserAddress>;
  updateAddress(id: string, input: UserAddressInput): Promise<UserAddress>;
  deleteAddress(id: string): Promise<void>;
  setDefaultShipping(id: string): Promise<UserAddress>;
  setDefaultBilling(id: string): Promise<UserAddress>;
}

const mockAddressesService: AddressesService = {
  fetchAddresses: mock.mockFetchAddresses,
  createAddress: mock.mockCreateAddress,
  updateAddress: mock.mockUpdateAddress,
  deleteAddress: mock.mockDeleteAddress,
  setDefaultShipping: mock.mockSetDefaultShipping,
  setDefaultBilling: mock.mockSetDefaultBilling,
};

const httpAddressesService: AddressesService = {
  fetchAddresses: http.httpFetchAddresses,
  createAddress: http.httpCreateAddress,
  updateAddress: http.httpUpdateAddress,
  deleteAddress: http.httpDeleteAddress,
  setDefaultShipping: http.httpSetDefaultShipping,
  setDefaultBilling: http.httpSetDefaultBilling,
};

export const addressesService: AddressesService = env.useMock
  ? mockAddressesService
  : httpAddressesService;
